import React, { useState, useEffect, useRef } from 'react';
import {
    Button,
    FormGroup,
    Label,
    Row,
    Col,
    Input,
    InputGroup,
    InputGroupText,
} from 'reactstrap';
import * as Yup from 'yup';
import moment from 'moment';
import { Formik, Field } from 'formik';
import { NavLink } from 'react-router-dom';
import { cloneDeep, find } from 'lodash';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import { default as ReactSelect } from "react-select";
import { components } from 'react-select';
// import Inficon from 'assets/icon/Inficon.svg'
import Tooltip from 'react-tooltip-lite';
import { ModuleAccess } from 'utils/moduleaccess';
import { Option, LimitedChipsContainer } from 'components/Options';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import Calendar from 'assets/icon/calendar-icon.svg';
import { dateFormate } from 'utils/columns';
import { faLeaf, faSlash } from '@fortawesome/free-solid-svg-icons';
import { isDisabled } from '@testing-library/user-event/dist/utils';

let hasDatePopupOpen = false;
let pharmacyData = [];
let pharmacyError = "Please Select Pharmacy Name";
let dateRangeError = "Please Select Date Range";

const validationSchema = Yup.object({
    //coveredEntityID: Yup.string().required('Please select covered entity'),
});

const SearchContainer = (props) => {

    const { orgId } = props;

    const { onSearch, onReset } = props;


    const [hasPHselected, setPHselected] = useState(true);
    const [selectedOption, setOptionSelected] = useState({ optionSelected: '-1' });
    const [isAddPermission, setIsAddPermission] = useState(false);
    const [selectedOpt, setOptSelected] = useState({ optSelected: '-1' });
    const [isSubmited, setIsSubmitted] = useState(false);
    const [isSubmitting, setSubmitting] = useState(true);
    const [loading, setLoading] = useState(false);
    const [startDate, setstartDate] = useState(null);
    const [endDate, setendDate] = useState(null);
    const [dateRangeValue, setDateRangeValue] = useState(1);


    const API = useAxios();

    const formikRef = useRef();

    const {
        states: { pharmacyreports },
        setStates,
        resetStates,
    } = useContextService();

    // const {
    //     searchTerms,
    // } = pharmacyreports;

    // let { pharmacyIDs,

    //     dateRange,
    // } = searchTerms;

    const accountStatusOpt = [
        { id: 'N', label: 'Pharmacy Claims' }

    ];

    const DateRangeOptions = [

        { id: '2', label: 'Last Month' },
        { id: '3', label: 'Last 30 Days' },
        { id: '4', label: 'Last 90 Days' },
        { id: '5', label: 'Last 180 Days' },
        { id: '6', label: 'Custom' },
    ];
    const AccountTypeselect=[
        { id: '1', label: 'ALL' },
        { id: '2', label: '340B' },
        { id: '3', label: 'GPO' },
        { id: '4', label: 'WAC' },
    ]


    const DateRangeTypeList = [{ code: 'Current Month', RangeTypeList: 'Current Month', Id: 1 }, { code: 'Last Month', RangeTypeList: 'Last Month', Id: 2 }, { code: 'Last 30 Days', RangeTypeList: 'Last 30 Days', Id: 3 }, { code: 'Last 90 Days', RangeTypeList: 'Last 90 Days', Id: 4 }, { code: 'Last 180 Days', RangeTypeList: 'Last 180 Days', Id: 5 }, { code: 'Custom', RangeTypeList: 'Custom', Id: 6 }];

    const hasPermission = (code) => {
        return ModuleAccess("PHR", code);
    }



    useEffect(() => {
        // pharmacyreports.pharmacyData = [];
        setOptionSelected({ optionSelected: '-1' });
        setDateRangeValue(1);
        // fetchPharmacy();
    }, [orgId]);

    const updateStates = (pharmacyreports) => {
        setStates('pharmacyreports', pharmacyreports);
    };

    // const fetchPharmacy = async () => {
    //     pharmacyData = [];
    //     let selectedOrgId = orgId.organizationID;
    //     if (selectedOrgId !== -1) {

    //         pharmacyData = [];
    //         // pharmacyreports.searchTerms.pharmacyIDs = {};
    //         updateStates(pharmacyreports);
    //         setSubmitting(true);
    //         setLoading(true);

    //         try {
    //             const { data } = await API.get(`CPConfig/CoveredEntity/pharmacieslist/${selectedOrgId}`, {
    //                 hasDefaultURL: true,
    //             });
    //             setLoading(false);
    //             setSubmitting(false);
    //             if (data) {
    //                 for (var x in data) {
    //                     pharmacyData.push({ "value": data[x].pharmacyID, "label": data[x].pharmacyName });
    //                 }
    //                 pharmacyIDs.pharmacyData = data;

    //                 // if (pharmacyData.length == 1) {
    //                 //     var ceData = [];
    //                 //     ceData.push(coveredEntitiesData[0])
    //                 //     advanceReport.searchTerms.coveredEntityIDs = ceData;
    //                 //     window.selectedCoveredEntittyId = ceData;
    //                 // }
    //                 // if (window.selectedCoveredEntittyId.length > 0) {
    //                 //     advanceReport.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
    //                 // }
    //                 updateStates(pharmacy)
    //                 if (pharmacyIDs) {

    //                     var pharmacySelected = {};
    //                     pharmacySelected.optionSelected = [];
    //                     for (var x in pharmacyIDs) {
    //                         pharmacySelected.optionSelected.push(pharmacyIDs[x]);
    //                     }
    //                     setOptionSelected({ optionSelected: '-1' });
    //                 }
    //             }
    //         } catch (err) {
    //             setLoading(false);
    //             setSubmitting(false);
    //         }
    //     }
    // };

    // const handlePHContractAction = async () => {
    //     let phId = formikRef.current.values.pharmacyId;
    //     if (phId != "") {
    //         handlePHContract(phId);
    //     }
    // }

    // const handlePharmacyChange = (selected, setFieldValue, value) => {

    //     if (selected) {

    //         setPHselected(true);
    //         setOptionSelected({
    //             optionSelected: selected
    //         });
    //         let isDisabled = value == "" ? true : false;
    //         setFieldValue("pharmacyIDs", selected);
    //         setSubmitting(isDisabled);
    //         let phIDs = [];
    //         for (var x in selected) {
    //             var rw = selected[x];
    //             phIDs.push(rw.value);

    //         }
    //         pharmacyreports.searchTerms.pharmacyIDs = phIDs;
    //         updateStates(pharmacyreports);
    //     }
    //     else {
    //         setFieldValue('pharmacyIDs', {});
    //         setPHselected(false);
    //     }

    // };

    const handleDateRangeChange = ({ target: { value } }, setFieldValue) => {
        if (value) {
            const statusID = parseInt(value) - 1;
            const findObj = DateRangeTypeList[statusID];
            setFieldValue('dateRange', value)
            pharmacyreports.dateRange = findObj;
            pharmacyreports.searchTerms.dateRangeID = findObj.Id;

            setDateRangeValue(findObj.Id);
        } else {
            setFieldValue('dateRange', '')
            pharmacyreports.dateRange = {};
            pharmacyreports.dateRangeID = null;
            setDateRangeValue(1);
        }

    };

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    // const handleStartDate = (startDate, setFieldValue) => {

    //     let stDate = dateFormate(startDate);
    //     setstartDate(stDate);
    //     setFieldValue('startDate', stDate);
    //     pharmacyreports.searchTerms.startDate = moment(new Date(startDate)).format(
    //         'MM/DD/YYYY'
    //     );
    // };

    // const handleEndDate = (endDate, setFieldValue) => {
    //     let enDate = dateFormate(endDate);
    //     setendDate(enDate);
    //     setFieldValue('endDate', enDate);
    //     pharmacyreports.searchTerms.endDate = moment(new Date(endDate)).format(
    //         'MM/DD/YYYY'
    //     );
    // };


    const handleSubmit = async (value, actions) => {

        setIsSubmitted(true);
        const { setSubmitting } = actions;

        let phIDs = [];

        for (var x in value.pharmacyIDs) {
            var rw = value.pharmacyIDs[x];
            phIDs.push(rw.value);

        }
        if (phIDs.length == 0) {
            setPHselected(false);
            setSubmitting(false);
        }
        if (phIDs.length > 0) {
            const values = cloneDeep(value);

            if (phIDs > [0]) {
                values.pharmacyIDs = phIDs;
                await onSearch(values);
            }

            if (startDate) values.startDate = startDate;
            if (endDate) values.endDate = endDate;
            // if (phIDs.length == 0) {
            //     values.pharmacyIDs = phIDs;

            // }
            pharmacyreports.search.currentPage = 1;
            updateStates(pharmacyreports);
            await onSearch(values);
            setIsSubmitted(false);
        }

    };

    const handelReset = ({ resetForm }) => {

        setIsSubmitted(false);
        setSubmitting();
        setPHselected(true);
        setstartDate(null);
        setendDate(null);
        window.selectedOption = "";
        onReset();
        // pharmacyreports.searchTerms.pharmacyIDs = [];

        resetForm();

        setDateRangeValue(1);
        // pharmacyreports.pharmacyData = [];
        // pharmacyreports.pharmacies = [];
        // pharmacyreports.dateRange = [];
        setOptionSelected({ optionSelected: '-1' });
        updateStates(pharmacyreports);
        resetStates('pharmacyreports');
    }

    return (
        <Formik
            innerRef={formikRef}
            onSubmit={handleSubmit}
            // initialValues={searchTerms}
            validationSchema={validationSchema}
            enableReinitialize={true}
            children={(props) => {
                const { handleSubmit, resetForm, setFieldValue } = props;
                return (
                    <div>
                        <div className='d-flex justify-content-between'>
                            <h5 className='f-15 text-primary font-weight-700'>
                                Search SB Reports
                            </h5>
                            {/*
                            <Tooltip content={(<div className='tip-list-info'
                                height={70}
                                width={200}
                            >
                                <p>
                                    Pharmacy Claims: This report type filters all claims based on their capture status, including captured, non-captured, and non-entity derived claims.
                                    Claims are pulled based on the date of service.
                                </p>
                                <p>
                                    Captured Claims: Claims that have been successfully captured and processed within the system.
                                    Non-Captured Claims: Claims that have not been successfully captured and remain unprocessed.
                                    Non-Entity Derived Claims: Claims where the client or covered entity cannot be determined.

                                </p>
                            </div>)} direction='left'>
                                <img src={Inficon} alt='' style={{ marginLeft: 0 }} />
                            </Tooltip> */}
                        </div>

                        <Row >
                            <Col md={4} sm={4} xs={6}>
                                {' '}
                                <FormGroup>
                                    <Label for='CoverdEntity'>CoveredEntity</Label>
                                    <ReactSelect
                                        name='CoverdEntity'
                                        options={[]}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        optionSelected={true}
                                        // components={{
                                        //     Option, ValueContainer: LimitedChipsContainer
                                        // }}
                                        isSearchable="true"
                                        // onChange={(value, phcy) =>
                                        //     handlePharmacyChange(value, setFieldValue, phcy)
                                        // }
                                        // value={selectedOption.optionSelected}
                                        className='claim_info required'
                                        maxMenuHeight={220}
                                        styles={{
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 99,
                                            }),
                                        }}
                                    />
                                    {(!hasPHselected) ? (
                                        <div className="text-danger f-12 position-absolute">
                                            {pharmacyError}
                                        </div>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md={4}  lg={4} sm={6} xs={6}  >
                                {' '}
                                <FormGroup>
                                    <Label for='accumulator'>Accumulator</Label>
                                  
                                      <Field
                                        // id='accumulator'
                                        name='accumulator'
                                        type='text'
                                        placeholder="Select Accumulator"
                                        autoComplete='off'
                                        defaultoption='--Select--'
                                       className="required"
                                        options={[]}
                                        value={[]}
                                        component={FormikSelectField}
                                        //  onChange={(e) => handelpatientStatus(e, setFieldValue) }
                                         keys={{
                                            id: 'id',
                                            label: 'label',
                                        }}
                                    />
                            {/* {patientstatuserr && <div className="text-danger font-size-12">{patientstatuserr}</div>} */}

                                </FormGroup>
                            </Col>
                            </Row>
                            <Row>
                            <h5 className='f-15 text-primary font-weight-700'>
                                Report Type Date
                            </h5>

                            <Col md={3} sm={3} xs={6}>
                                <FormGroup>
                                    <Label>Report Type</Label>
                                    <Input
                                        id="accountStatus"
                                        name="accountStatus"
                                        type='select'
                                        // disabled={true}
                                    >
                                        {/* <option value={''}>Pharmacy Claims</option> */}
                                        {accountStatusOpt.map((status) => {
                                            const { id, label } = status;
                                            return (
                                                <option key={id} value={id}>
                                                    {label}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                </FormGroup>

                            </Col>

                            <Col md={3} sm={3} xs={6}>
                                {' '}
                                <FormGroup>
                                    <Label for='dateRange'>Date Range</Label>
                                    <Field
                                        name="dateRange"
                                        id="dateRange"
                                        type="text"
                                        autoComplete="off"
                                        // className='claim_info required'
                                        value={dateRangeValue}
                                        component={FormikSelectField}
                                        options={DateRangeOptions}
                                        onChange={(val) => handleDateRangeChange(val, setFieldValue)}
                                        defaultoption='Current Month'
                                        defaultValue={1}
                                        keys={{
                                            id: "id",
                                            label: "label",
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3} sm={3} xs={6}>
                                {' '}
                                <FormGroup>
                                    <Label for='accounttype'>Account Type</Label>
                                    <Field
                                        name="accounttype"
                                        id="accounttype"
                                        type="text"
                                        autoComplete="off"
                                        // className='claim_info required'
                                        value={dateRangeValue}
                                        component={FormikSelectField}
                                        options={AccountTypeselect}
                                        onChange={(val) => handleDateRangeChange(val, setFieldValue)}
                                        defaultoption='Current Month'
                                        defaultValue={1}
                                        keys={{
                                            id: "id",
                                            label: "label",
                                        }}
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={3} sm={6}>
                                <Row>
                                    <Col>
                                        <FormGroup hidden={dateRangeValue != '6'}>
                                            <Label>Start Date</Label>
                                            <InputGroup onMouseLeave={handleMouseLeave}>
                                                <Field
                                                    type='text'
                                                    id='startDate'
                                                    name='startDate'
                                                    autoComplete='off'
                                                    placeholder='Select a date'
                                                    value={startDate}
                                                    component={FormikDatePicker}
                                                    // onChange={handleStartDate}
                                                    onChange={(val) => handleStartDate(val, setFieldValue)}
                                                // disabled={dateRangeValue != '6'}
                                                />
                                                <InputGroupText
                                                    onClick={() => handleDateClick('startDate')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col xs='auto' className='pt-3 mt-3'>
                                        <Label className='mt-1'>-</Label>
                                    </Col>
                                    <Col>
                                        <FormGroup hidden={dateRangeValue != '6'}>
                                            <Label>End Date</Label>
                                            <InputGroup onMouseLeave={handleMouseLeave}>
                                                <Field
                                                    type='text'
                                                    id='endDate'
                                                    name='endDate'
                                                    autoComplete='off'
                                                    placeholder='Select a date'
                                                    value={endDate}
                                                    component={FormikDatePicker}
                                                    //onChange={handleEndDate}
                                                    onChange={(val) => handleEndDate(val, setFieldValue)}
                                                // disabled={dateRangeValue != '6'}
                                                />
                                                <InputGroupText
                                                    onClick={() => handleDateClick('endDate')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                          <Row className='flex justify-content-end'>
                          <Col md='auto' className=' mt-1'>
                                <Label>{''}</Label>
                                <Button
                                    // disabled={isSubmitting}
                                    // setIsSubmitted={true}
                                    onClick={handleSubmit}
                                    color='primary'
                                    className='ms-3'
                                >
                                    Search
                                </Button>
                                <Button color='primary'
                                    onClick={() => handelReset(props)}
                                >
                                    Reset
                                </Button>
                            </Col>
                          </Row>
                            
                        </Row>
                    </div>
                );
            }}
        ></Formik>
    );
};

export default SearchContainer;
